import * as isActive from './../../activity-functions';

function initFooter(authorizationResponse) {
  let footer = document.querySelector('.single-spa-application-venue-footer');
  if (!footer) return;

  const lang = authorizationResponse.language;
  const isHostingInit = authorizationResponse.hosting;
  const machineNumber = window.isLocal && isHostingInit ? authorizationResponse.hosting.machine.id : window.MachineNumber;
  const machineLocation = window.isLocal && isHostingInit ? authorizationResponse.hosting.machine.location.id : window.MachineLocation;
  let termsAndConditionsUrl;
  if (isHostingInit) {
    const hubUrl = authorizationResponse.hosting.machine.location.hubUrl;
    const dict = initializeDictionary();
    termsAndConditionsUrl = hubUrl + dict.get(lang);
  }
  const localization = footerLocalizationObj[lang];

  document.querySelector(
    '.single-spa-application-venue-footer-version'
  ).textContent = `(${machineLocation} - ${machineNumber})`;
  document.querySelector('.single-spa-application-venue-footer-copyright').textContent = localization.copyright.replace(
    '{currentYear}',
    new Date().getFullYear()
  );
  document.querySelector('.single-spa-application-venue-footer-support').textContent = localization.support;

  if (authorizationResponse.user.isAdmin) {
    document.querySelector('.data-venue-walkme-id').setAttribute("data-venue-walkme", "IsAdmin");  
  }

  if (authorizationResponse) {
    var script = document.createElement("script");
    script.innerHTML = "window.zE('webWidget', 'identify', { name: '" +
      authorizationResponse.user.fullName + "',  email: '" + authorizationResponse.user.email + "' }); ";

    document.head.appendChild(script);
  }
  
  if (termsAndConditionsUrl) {
    document.querySelector('#termsAndConditionsURL').setAttribute('href', termsAndConditionsUrl);
    document.querySelector('#termsAndConditionsURL').textContent = localization.termsAndConditions;
  }
  
  footer.style.display = isActive.footer(window.location) ? 'flex' : 'none';
  window.addEventListener('popstate', function(event) {
    if (footer) {
      footer.style.display = isActive.footer(window.location) ? 'flex' : 'none';
    }
  });
}

//#region Footer localization
const footerLocalizationObj = {
  en: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: 'Need Support? Please call 1-888-773-8379.',
    termsAndConditions: 'Terms & Conditions'
  },
  de: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: 'Brauche Unterstützung? Rufen Sie bitte 1-888-773-8379.',
    termsAndConditions: 'Geschäftsbedingungen'
  },
  es: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: 'Necesidad de apoyo? Por favor llama 1-888-773-8379.',
    termsAndConditions: 'Términos y condiciones'
  },
  fr: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: "Besoin de soutien ? Appelez s'il vous plaît 1-888-773-8379.",
    termsAndConditions: 'Conditions générales'
  },
  it: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: 'Hai bisogno di supporto? Si prega di chiamare 1-888-773-8379.',
    termsAndConditions: 'Termini e condizioni'
  },
  ja: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: 'ヘルプデスク : 1-888-773-8379.',
    termsAndConditions: '使用条件'
  },
  ko: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: '고객기술지원 1-888-773-8379.',
    termsAndConditions: '이용 약관'
  },
  pt: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: 'precisa de Suporte? Por favor ligue 1-888-773-8379.',
    termsAndConditions: 'Termos e Condições'
  },
  ru: {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: 'Нужна поддержка? Пожалуйста позвони 1-888-773-8379.',
    termsAndConditions: 'Условия и положения'
  },
    'zh-hans': {
    copyright: '© {currentYear} Donnelley Financial Solutions',
    support: '需要支持? 请打电话 1-888-773-8379.',
    termsAndConditions: '条款及条件'
  }
};

function initializeDictionary() {
  let dict = new Map();
  dict.set('en', 'StaticContent/VenueTerms-English.pdf');
  dict.set('ja', 'StaticContent/VenueTerms-Japanese.pdf');
  dict.set('pt', 'StaticContent/VenueTerms-BrazilianPortuguese.pdf');
  dict.set('de', 'StaticContent/VenueTerms-German.pdf');
  dict.set('fr', 'StaticContent/VenueTerms-French.pdf');
  dict.set('es', 'StaticContent/VenueTerms_SPA.pdf');
  dict.set('it', 'StaticContent/VenueTerms_ITA.pdf');
  dict.set('ru', 'StaticContent/VenueTerms_RUS.pdf');
  dict.set('ko', 'StaticContent/VenueTerms_KOR.pdf');
  dict.set('zh-hans', 'StaticContent/VenueTerms_SCH.pdf');
  return dict;
}
//#endregion
export { initFooter };
